module.exports = "<app-unprocessed-claims></app-unprocessed-claims>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/billing-provider/unprocess-claims-prov/unprocess-claims-prov.component.html
// module id = 2408
// module chunks = 66